<template>
    <footer class="bg-white rounded-lg shadow-sm m-4 dark:bg-gray-800">
        <div class="w-full mx-auto max-w-screen-xl p-4 md:flex md:items-center md:justify-between">
            <span class="text-sm text-gray-500 sm:text-center dark:text-gray-400">© 2025 <router-link
                    to="/" class="hover:underline mx-1">PapoteAI</router-link>  All Rights Reserved.
            </span>
            <ul
                class="flex flex-wrap items-center mt-3 text-sm font-medium text-gray-500 dark:text-gray-400 sm:mt-0">
                <li>
                    <router-link to="/about" class="hover:underline me-4 md:me-6">About</router-link>
                </li>
                <li>
                    <router-link to="/privacy" class="hover:underline me-4 md:me-6">Privacy Policy</router-link>
                </li>
                <li>
                    <router-link to="/tos" class="hover:underline me-4 md:me-6">Terms of Service</router-link>
                </li>
                <li>
                    <router-link to="/contact" class="hover:underline">Contact</router-link>
                </li>
            </ul>
        </div>
    </footer>
</template>
